<template>
  <GlobalGraph class="graph" :key="componentKey" v-if="series.length" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :title="graphTitle" :loading="loading" :theme="theme" />
</template>

<script>
import { mapGettersMixin } from '@/util/mixin/index'
import GlobalGraph from '@/components/common/GlobalGraph.vue'

import {
  EventBus
} from '@/services/event-bus'

export default {
  mixins: [ mapGettersMixin ],
  components: {
    GlobalGraph
  },
  props: {
    series: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    xAxis: {
      type: Array
    },
    yAxis: {
      type: Array
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      componentKey: 0
    }
  },
  computed: {
    graphTitle() {
      return {
        text: this.title,
        left: 'center'
      }
    }
  },
  created() {
    EventBus.$on('reset:graph', this.resetKey)
  },
  beforeDestroy() {
    EventBus.$off('reset:graph', this.resetKey)
  },
  methods: {
    resetKey() {
      this.componentKey++
    }
  }
}
</script>

<style scoped>
.graph {
  width: 100%;
  height: 490px;
}
</style>
